import React from 'react';
import './App.css';
import Filters from './Filters.jsx';
import AnimalList from './AnimalList.jsx';
import AnimalModal from './AnimalModal.jsx'
import { StateProvider, StateReducer } from './AppContext.jsx';

function App() {

  const initialState = window.adoptMe ? window.adoptMe : {};

  return (
    <StateProvider 
      initialState={initialState}
      reducer={StateReducer}>
      <Filters />
      <AnimalList />
      <AnimalModal />
    </StateProvider>
  );
}

export default App;
